import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/product'
export function getList(params) {
  return axios.get(`${ApiUrl}/list/`, {
    params: { is_manual_order: 0, ...params }
  })
}

export function del(product_id) {
  return axios.delete(`${ApiUrl}/${product_id}/`)
}

export function getDetail(product_id) {
  return axios.get(`${ApiUrl}/${product_id}/detail/`)
}

export function add(data) {
  return axios.post(`${ApiUrl}/add/`, data)
}

export function edit(product_id, data) {
  return axios.put(`${ApiUrl}/${product_id}/`, data)
}

export function batchShelf(data) {
  return axios.post(`${ApiUrl}/batch_shelf/`, data)
}
